import { getBaseURL } from "@/services/apiService";
import { CompositePropagator, W3CTraceContextPropagator } from "@opentelemetry/core";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";

import { AmznTraceIdPropagator } from "./amznTraceIdPropagator";

let initialized = false;

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

// Scoped to our own API origin (same-origin in prod, localhost:8000 in dev) so
// traceparent / X-Amzn-Trace-Id aren't leaked to third-party cross-origin calls
// (Supabase Auth, S3, Stripe).
const API_ORIGIN = new URL(getBaseURL(), window.location.origin).origin;
const PROPAGATE_TRACE_HEADER_CORS_URLS = [new RegExp(`^${escapeRegExp(API_ORIGIN)}/`)];

export function initOtel(): void {
  if (initialized) return;
  initialized = true;

  // W3C for app/Langfuse; X-Amzn-Trace-Id gets X-Ray Root= + W3C traceparent
  // so ALB logs stay substring-searchable by client trace/span ids.
  new WebTracerProvider().register({
    propagator: new CompositePropagator({
      propagators: [new W3CTraceContextPropagator(), new AmznTraceIdPropagator()],
    }),
  });

  registerInstrumentations({
    instrumentations: [
      new XMLHttpRequestInstrumentation({
        propagateTraceHeaderCorsUrls: PROPAGATE_TRACE_HEADER_CORS_URLS,
      }),
      new FetchInstrumentation({
        propagateTraceHeaderCorsUrls: PROPAGATE_TRACE_HEADER_CORS_URLS,
      }),
    ],
  });
}
